import React from "react";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import PropTypes from "prop-types";
Chart.register();

const DailyPostStatusChart = ({ dashboardInfo }) => {
  // console.log("info", dashboardInfo);
  const userData = {
    // labels: dashboardInfo?.map((data) => data.day),
    labels: dashboardInfo?.map((data) => data.txt_screen_name),

    datasets: [
      // {
      //   // label: "Weekly Posts",
      //   label: "Media Count",
      //   data: dashboardInfo?.map((data) => data.total_posts),
      //   backgroundColor: "#4090F3",
      //   tension: 0.4,
      //   borderWidth: 0,
      //   borderRadius: 4,
      //   borderSkipped: false,
      //   borderColor: "black",
      //   lineWidth: 0,
      //   maxBarThickness: 6,
      // },
      {
        label: "Media Count",
        data: dashboardInfo?.map((data) => data.count),
        backgroundColor: "#4090F3",
        tension: 0.4,
        borderWidth: 0,
        borderRadius: 4,
        borderSkipped: false,
        borderColor: "black",
        lineWidth: 0,
        maxBarThickness: 6,
      },
    ],
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 500,
            beginAtZero: true,
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            color: "#fff",
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      <Bar data={userData} height={100} />
    </div>
  );
};

DailyPostStatusChart.propTypes = {
  dashboardInfo: PropTypes.arrayOf(PropTypes.object),
};

export default DailyPostStatusChart;
